module.exports = __webpack_public_path__ + "img/vector.8095959b.png";